import _ from 'lodash';

import { State } from '../../setup/types';

export const shouldShowHelpDialog = (state?: State) =>
    _.get(state, 'serviceInfo.showHelpDialog', false);

export const shouldShowChangeDialog = (state?: State) =>
    _.get(state, 'serviceInfo.showChangeDialog', false);
